import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit, inject } from '@angular/core';
import { Observable } from 'rxjs';

import { ProductContextFacade } from 'ish-core/facades/product-context.facade';
import { ProductView } from 'ish-core/models/product-view/product-view.model';
import { VariationAttributePipe } from 'ish-core/pipes/variation-attribute.pipe';

@Component({
  selector: 'ish-product-variation-display',
  templateUrl: './product-variation-display.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, VariationAttributePipe],
})
export class ProductVariationDisplayComponent implements OnInit {
  private context = inject(ProductContextFacade);

  product$: Observable<ProductView>;
  visible$: Observable<boolean>;

  ngOnInit() {
    this.product$ = this.context.select('product');
    this.visible$ = this.context.select('displayProperties', 'variations');
  }
}
